/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbImmutableRecord } from "abreact/utils/AbImmutableRecord";
import { Assert } from "abweb/utils/Assert";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { NullUtils } from "abweb/utils/NullUtils";
import { ObjectUtils } from "abweb/utils/ObjectUtils";
// import AbstractOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue;
// import WithoutNodeType = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.WithoutNodeType;

export class AbstractOperandValueImplBaseRecordClassFactory {
  /* eslint-disable-next-line abinitio/type-declaration */
  createBaseRecordClass(defaultState) {
    class AbstractOperandValueImpl extends AbImmutableRecord.Class(defaultState) {
      get isEditableOrDefault() {
        return this.isEditable ?? true;
      }
      get isDisabledOrDefault() {
        return this.isDisabled ?? false;
      }
      get expAdditionalData() {
        return this.expAdditionalDataObject?.value;
      }
      get expAdditionalDataOrThrow() {
        return NullUtils.assertDefined(this.expAdditionalData);
      }
      withId(id) {
        return this.with({
          id
        });
      }
      withDescription(description) {
        return this.with({
          description
        });
      }
      withIsEditable(isEditable) {
        return this.with({
          isEditable
        });
      }
      withIsDisabled(isDisabled) {
        return this.with({
          isDisabled
        });
      }
      withExpAdditionalData(expAdditionalData) {
        return this.with({
          expAdditionalDataObject: AbImmutableRecord.State.Object.fromNullable(expAdditionalData)
        });
      }
      withIntegrationConfiguration(integrationConfiguration) {
        return this.with({
          integrationConfiguration
        });
      }
      transformRecursive(transformer, predicate) {
        if (predicate == null || predicate(this)) {
          const transformed = transformer(this);
          Assert.assert(ClassUtils.getClass(transformed) === ClassUtils.getClass(this));
          return transformed;
        }
        return this;
      }
      stateWithoutNodeType() {
        return {
          id: this.id,
          description: this.description,
          isEditable: this.isEditable,
          isDisabled: this.isDisabled,
          expAdditionalDataObject: this.expAdditionalDataObject,
          integrationConfiguration: this.integrationConfiguration
        };
      }
      toExpExpressionNode() {
        return {
          id: this.id,
          nodeType: this.expExpressionNodeNodeType,
          description: this.description,
          editable: this.isEditable ? undefined : false,
          disabled: this.isDisabled ? true : undefined,
          additionalData: ObjectUtils.deepCopy(this.expAdditionalData),
          integrationConfiguration: this.integrationConfiguration?.toObject()
        };
      }
    }
    return AbstractOperandValueImpl;
  }
}
export let AbstractOperandValueImpl;
(function (_AbstractOperandValueImpl) {
  function getDefaultState() {
    return {
      id: undefined,
      // Defined in constructor
      expExpressionNodeNodeType: undefined,
      // Defined in constructor
      description: undefined,
      isEditable: true,
      isDisabled: false,
      expAdditionalDataObject: undefined,
      integrationConfiguration: undefined
    };
  }
  _AbstractOperandValueImpl.getDefaultState = getDefaultState;
})(AbstractOperandValueImpl || (AbstractOperandValueImpl = {}));
//# sourceMappingURL=AbstractOperandValueImplBaseRecordClassFactory.js.map
